/* Define your initial state here.
 *
 * If you change the type from object to something else, do not forget to update
 * src/container/App.js accordingly.
 */
import * as commonActionTypes from '../action/CommonActionTypes';
import { SET_CURRENT_USER_SUCCESS, USER_LOGGED_OUT } from '../auth/actionTypes';

const initialState = {
  openProfile: false,
  openBookmarks: false,
  refreshBookmarks: true
};

const reducer = (state = initialState, action = {}) => {
  /* Keep the reducer clean - do not mutate the original state. */
  // const nextState = Object.assign({}, state);

  switch (action.type) {
    case `${commonActionTypes.OPEN_PROFILE}`: {
      return Object.assign({}, state, {
        openProfile: true,
        openBookmarks: false
      });
    }

    case `${commonActionTypes.CLOSE_PROFILE}`: {
      return Object.assign({}, state, {
        openProfile: false,
        openBookmarks: false
      });
    }

    case `${commonActionTypes.OPEN_BOOKMARKS}`: {
      return Object.assign({}, state, {
        openProfile: false,
        openBookmarks: true
      });
    }

    case `${commonActionTypes.CLOSE_BOOKMARKS}`: {
      return Object.assign({}, state, {
        openProfile: false,
        openBookmarks: false
      });
    }

    case `${commonActionTypes.REFRESH_BOOKMARKS}`: {
      return Object.assign({}, state, {
        refreshBookmarks: action.refreshBookmarks
      });
    }

    //Set country and cost center from session storage
    case `${commonActionTypes.SET_GLOBAL_FILTERS}`: {
      const newState = Object.assign({}, state, {
        costcenter: action.data.costcenter,
        country: action.data.country
      });
      // localStorage.setItem('legacy/activeSession', JSON.stringify(newState));

      return newState;
    }

    //Set global dynamic filter
    case `${commonActionTypes.SET_GLOBAL_DYNAMIC_FILTERS}`: {
      return Object.assign({}, state, {
        dynamicFilters: action.data
      });
    }

    // reset Set country and cost center
    case SET_CURRENT_USER_SUCCESS:
    case USER_LOGGED_OUT: {
      return initialState;
    }

    default: {
      /* Return original state if no actions were consumed. */
      return state;
    }
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducer/CommonReducer.js